
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { UpdateItem, GunGrubu, gunlereGrupla } from "@/components/infos/guncellemeler";

@Component
export default class GuncellemelerDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Array,   default: () => [] }) items!: UpdateItem[];
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) hata!: boolean;
  @Prop({ type: Date,    default: () => new Date() }) simdi!: Date;

  internalValue = this.value;

  @Watch("value") onV(n: boolean) { this.internalValue = n; }
  @Watch("internalValue") onIV(n: boolean) { this.$emit("input", n); }

  /** Aynı günün duyuruları tek kartta, ürün bölümleri halinde; son gün en üstte */
  get gunler(): GunGrubu[] {
    return gunlereGrupla(this.items, this.simdi);
  }

  productColorOf(productId: number): string {
    switch (productId) {
      case 1: return "#761616";
      case 2: return "#0f547b";
      case 3: return "#4c7128";
      case 4: return "red";
      default: return "primary";
    }
  }
}
